module.exports = __webpack_public_path__ + "static/media/Close.ca69ec48.svg";